"use client";

import Link from "next/link";
import { createContext, useContext, type ComponentProps } from "react";

// Три дизайна на одном содержании. Дизайн и префикс адреса приходят из layout своей группы страниц.
export type DesignId = "institut" | "gallery" | "sport";

export const DESIGNS: { id: DesignId; label: string; base: string; note: string }[] = [
  { id: "institut", label: "Институт", base: "", note: "Исходный: сумерки, научный тон" },
  { id: "gallery", label: "Каталог", base: "/gallery", note: "Белый холст и вырезки" },
  { id: "sport", label: "Спорт", base: "/sport", note: "Кампания с кадрами с земли" },
];

const Ctx = createContext<{ design: DesignId; base: string }>({ design: "institut", base: "" });

export function DesignProvider({ design, children }: { design: DesignId; children: React.ReactNode }) {
  const base = DESIGNS.find((d) => d.id === design)!.base;
  return <Ctx.Provider value={{ design, base }}>{children}</Ctx.Provider>;
}

export const useDesign = () => useContext(Ctx);

// "/catalog" → "/gallery/catalog", "/#map" → "/gallery#map", "/" → "/gallery"
export function withBase(base: string, href: string) {
  // /api и мета-страница /showcase общие для всех дизайнов
  if (!href.startsWith("/") || href.startsWith("/api") || href.startsWith("/showcase")) return href;
  if (href === "/") return base || "/";
  if (href.startsWith("/#")) return (base || "/") + href.slice(1);
  return base + href;
}

// Внутренняя ссылка внутри текущего дизайна
export function L({ href, ...rest }: ComponentProps<typeof Link> & { href: string }) {
  const { base } = useDesign();
  return <Link href={withBase(base, href)} {...rest} />;
}
